import type { FilterItem } from '.';

/** Flatten filter item tree to query field names owned by one filter group. */
export const collectFilterFieldKeys = (
  filterItems: FilterItem[] | undefined
): string[] => {
  if (!filterItems?.length) return [];
  const keys: string[] = [];
  filterItems.forEach((filter) => {
    if (filter.filters?.length) {
      filter.filters.forEach((subFilter) => {
        keys.push(subFilter.field);
      });
    } else {
      keys.push(filter.field);
    }
  });
  return keys;
};
